import { Text, Colors } from 'library';
import { Employment } from 'parent-portal/provider-profile/providerProfileModels';
import React from 'react';
import { formatMonthYear } from 'shared/Dates';

export default function PreviousChildcareCenterJobExperience({ employment }: { employment: Employment[] }) {
    return (
        <div style={{ borderRadius: 25, backgroundColor: Colors.lightTurq }}>
            <div style={{ padding: 20 }}>
                <Text
                    color={Colors.turquoise}
                    variant="body1"
                    bold
                    textStyle={{ letterSpacing: 3.2, textTransform: 'uppercase' }}
                >
                    Employment History
                </Text>
                {employment.length > 0 ? (
                    employment.map((e) => (
                        <div style={{ marginTop: '2%', marginBottom: '2%' }}>
                            <Text>
                                <b>{e.role}</b> {e.start_date ? formatMonthYear(e.start_date) : ''}
                                {e.end_date ? ` - ${formatMonthYear(e.end_date)}` : ''}
                            </Text>
                            <Text variant="body2">{e.employer_name}</Text>
                            <Text variant="body2">{e.description}</Text>
                        </div>
                    ))
                ) : (
                    <Text variant="caption">
                        No employment reported on file. This doesn't mean they have no previous employment. It means
                        they haven't added it to their Tandem profile yet!
                    </Text>
                )}
            </div>
        </div>
    );
}
